import { render } from "./VideoErrorComponent.vue?vue&type=template&id=581525e2"
import script from "./VideoErrorComponent.vue?vue&type=script&lang=ts"
export * from "./VideoErrorComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script